export function getSiteHeaderScrollOffset(expectCollapsedMobileHeader: boolean): number {
  const siteHeader = document.querySelector('.site-header');
  if (!siteHeader) return 0;

  if (!expectCollapsedMobileHeader || !window.matchMedia('(max-width: 768px)').matches) {
    return siteHeader.getBoundingClientRect().height;
  }

  const nav = siteHeader.querySelector('.site-header__nav');
  if (!nav) return siteHeader.getBoundingClientRect().height;

  return nav.getBoundingClientRect().height + 16;
}

export function scrollBelowSiteHeader(el: HTMLElement, behavior: ScrollBehavior = 'smooth') {
  const mobile = window.matchMedia('(max-width: 768px)').matches;

  const align = (scrollBehavior: ScrollBehavior) => {
    const headerOffset = getSiteHeaderScrollOffset(mobile);
    const top = window.scrollY + el.getBoundingClientRect().top - headerOffset;
    window.scrollTo({ top: Math.max(0, top), behavior: scrollBehavior });
  };

  align(behavior);

  if (!mobile || behavior === 'auto') return;

  let finalized = false;
  const finalize = () => {
    if (finalized) return;
    finalized = true;
    align('auto');
  };

  window.setTimeout(finalize, 400);

  const onScrollEnd = () => {
    window.removeEventListener('scrollend', onScrollEnd);
    window.setTimeout(finalize, 50);
  };
  if ('onscrollend' in window) {
    window.addEventListener('scrollend', onScrollEnd, { once: true });
  }
}

export function scrollMobileWizardToStepBar(
  stepBarEl: HTMLElement | null,
  mobileStepEl?: HTMLElement | null,
) {
  if (!stepBarEl || !window.matchMedia('(max-width: 768px)').matches) return;

  const align = () => scrollBelowSiteHeader(stepBarEl, 'auto');

  align();
  requestAnimationFrame(() => {
    requestAnimationFrame(align);
  });

  if (!mobileStepEl || typeof ResizeObserver === 'undefined') return;

  const ro = new ResizeObserver(() => align());
  ro.observe(mobileStepEl);
  window.setTimeout(() => ro.disconnect(), 600);
}

export function syncMobileHeaderOffsetCssVar() {
  const h = getSiteHeaderScrollOffset(true);
  document.documentElement.style.setProperty('--mynazca-header-h', `${h}px`);
}

const MOBILE_EDITOR_MIN_H = 200;

export function syncMobilePreviewLayoutCssVars(
  stepBarEl: HTMLElement | null,
  mobileStepEl: HTMLElement | null,
) {
  syncMobileHeaderOffsetCssVar();
  const stepH = stepBarEl?.getBoundingClientRect().height ?? 0;
  document.documentElement.style.setProperty('--mynazca-step-bar-h', `${Math.ceil(stepH)}px`);

  if (!mobileStepEl || !window.matchMedia('(max-width: 768px)').matches) {
    document.documentElement.style.setProperty('--mynazca-mobile-editor-h', '0px');
    return;
  }

  const top = Math.max(0, mobileStepEl.getBoundingClientRect().top);
  const h = Math.max(MOBILE_EDITOR_MIN_H, Math.ceil(window.innerHeight - top));
  document.documentElement.style.setProperty('--mynazca-mobile-editor-h', `${h}px`);
}

export function clearMobilePreviewLayoutCssVars() {
  document.documentElement.style.setProperty('--mynazca-step-bar-h', '0px');
  document.documentElement.style.setProperty('--mynazca-mobile-editor-h', '0px');
}
